export default __webpack_public_path__ + "static/media/african2.8a27fce8.jpg";